import HiddenTypography from 'components/hidden-typography/hidden-typography.component';
import { useTranslation } from 'react-i18next';
import { selectDisplayTotalWithoutGratuityWithTip } from 'redux/cart/cart.selectors';
import { useReduxSrAlert } from '../sr-alerts.hooks';

const SrCartTotalAlert = () => {
  const { t } = useTranslation();
  const alertMessage = useReduxSrAlert(
    selectDisplayTotalWithoutGratuityWithTip,
    totalOrderSubTotal =>
      t('orderTotalSrAlert', { cartTotal: totalOrderSubTotal }),
  );

  return <HiddenTypography role="alert">{alertMessage}</HiddenTypography>;
};
export default SrCartTotalAlert;
